import styled from 'styled-components';
export const BadgeWrapper = styled.div `
  ${({ theme, variant }) => theme.badge[variant]}
  padding: 2px 14px;
  display: flex;
  width: fit-content;
  height: 25px;
  min-height: 25px;
  max-height: 25px;
  justify-content: center;
  align-items: center;
  -webkit-font-smoothing: antialiased;
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  ${({ theme }) => theme.common.Ellipsis};
  font-size: 14px;
  line-height: 22px;
`;
//# sourceMappingURL=BKJBadge.styled.js.map